"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleRoomFilterValue = exports.toggleOperatorFilterValue = exports.toggleHourRangeFilterValue = exports.getPrimaryBackgroundColor = exports.getIsRoomFilterMatch = exports.getIsRoomFilterEmpty = exports.getIsRoomFilterActive = exports.getIsOperatorFilterMatch = exports.getIsOperatorFilterEmpty = exports.getIsOperatorFilterActive = exports.getIsHourRangeFilterMatch = exports.getIsHourRangeFilterEmpty = exports.getIsHourRangeFilterActive = exports.createFilters = exports.createFilter = void 0;
var _ramda = require("ramda");
var _moment = _interopRequireDefault(require("moment"));
var _rgbHex = _interopRequireDefault(require("rgb-hex"));
var _hexRgb2 = _interopRequireDefault(require("hex-rgb"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var createFilter = exports.createFilter = function createFilter(filterName, initialValue) {
  return _defineProperty({}, filterName, initialValue);
};
var createFilters = exports.createFilters = function createFilters() {
  return (0, _ramda.mergeAll)([createFilter('rooms', new Set()), createFilter('operators', new Set()), createFilter('outbound', new Set()), createFilter('inbound', new Set())]);
};
var getIsRoomFilterActive = exports.getIsRoomFilterActive = function getIsRoomFilterActive(value, filterEntity) {
  return filterEntity.has(value);
};
var getIsOperatorFilterActive = exports.getIsOperatorFilterActive = getIsRoomFilterActive;
var getIsHourRangeFilterActive = exports.getIsHourRangeFilterActive = getIsRoomFilterActive;
var toggleRoomFilterValue = exports.toggleRoomFilterValue = function toggleRoomFilterValue(value, filterEntity) {
  var copy = new Set(filterEntity);
  if (copy.has(value)) {
    copy.delete(value);
  } else {
    copy.add(value);
  }
  return copy;
};
var toggleOperatorFilterValue = exports.toggleOperatorFilterValue = toggleRoomFilterValue;
var toggleHourRangeFilterValue = exports.toggleHourRangeFilterValue = toggleRoomFilterValue;
var getIsRoomFilterEmpty = exports.getIsRoomFilterEmpty = function getIsRoomFilterEmpty(filterEntity) {
  return filterEntity.size === 0;
};
var getIsOperatorFilterEmpty = exports.getIsOperatorFilterEmpty = getIsRoomFilterEmpty;
var getIsHourRangeFilterEmpty = exports.getIsHourRangeFilterEmpty = getIsRoomFilterEmpty;
var getIsRoomFilterMatch = exports.getIsRoomFilterMatch = function getIsRoomFilterMatch(offer, filterEntity) {
  return getIsRoomFilterEmpty(filterEntity) || filterEntity.has(offer.room.id);
};
var getIsOperatorFilterMatch = exports.getIsOperatorFilterMatch = function getIsOperatorFilterMatch(offer, filterEntity) {
  return getIsOperatorFilterEmpty(filterEntity) || filterEntity.has(offer.operator);
};
var getIsHourRangeFilterMatch = exports.getIsHourRangeFilterMatch = function getIsHourRangeFilterMatch(flights, filterEntity) {
  if (getIsHourRangeFilterEmpty(filterEntity) || !flights) return true;
  var filterEntityAsArray = _toConsumableArray(filterEntity);
  return (0, _ramda.call)((0, _ramda.pipe)((0, _ramda.map)(function (flight) {
    var dateAsMoment = (0, _moment.default)(flight.begin, 'YYYY-MM-DD HH:mm:ss');
    var dateWithTime = flight.begin !== dateAsMoment.format('YYYY-MM-DD');
    return dateWithTime ? dateAsMoment : null;
  }), (0, _ramda.filter)(Boolean), (0, _ramda.ifElse)(_ramda.isEmpty, _ramda.T, (0, _ramda.any)(function (dateAsMoment) {
    var hours = dateAsMoment.hours();
    return (0, _ramda.any)(function (_ref2) {
      var from = _ref2.from,
        to = _ref2.to;
      return hours >= from && hours <= to;
    }, filterEntityAsArray);
  }))), flights);
};
var getPrimaryBackgroundColor = exports.getPrimaryBackgroundColor = function getPrimaryBackgroundColor(theme) {
  var primaryColor = theme.primaryColor;
  var _hexRgb = (0, _hexRgb2.default)(primaryColor),
    red = _hexRgb.red,
    green = _hexRgb.green,
    blue = _hexRgb.blue;
  var mixColorWithWhite = function mixColorWithWhite(color) {
    return (color + 255) / 2;
  };
  return "#".concat((0, _rgbHex.default)(mixColorWithWhite(red), mixColorWithWhite(green), mixColorWithWhite(blue)));
};